<template>
  <div class="help-form ">
    <div class="warp">
      <a-form :form="form" :wrapper-col="{ span: 24 }" @submit="handleSubmit">
        <div class="flex-row justify-between">
          <div class="form-block">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="公司名称：">
                  <div>
                    <a-input
                      placeholder="请输入您的公司名称"
                      v-decorator="[
                        'name',
                        {
                          rules: [
                            { required: true, message: '请输入您的公司名称！' },
                          ],
                        },
                      ]"
                    />
                  </div>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="所属行业：">
                  <a-input
                    placeholder="请输入您所属的行业"
                    v-decorator="[
                      'cname',
                      {
                        rules: [
                          { required: true, message: '请输入您所属的行业！' },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="12">
                <a-row :gutter="24">
                  <a-col :span="24">
                    <a-form-item label="联系人姓名：">
                      <div>
                        <a-input
                          placeholder="请输入您的姓名"
                          v-decorator="[
                            'contactPerson-name',
                            {
                              rules: [
                                {
                                  required: true,
                                  message: '请输入您的姓名！',
                                },
                              ],
                            },
                          ]"
                        />
                      </div>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24" class="formhelp_input">
                  <a-col :span="24">
                    <a-form-item label="联系人手机：">
                      <a-input
                        :max-length="11"
                        placeholder="请输入您的手机号码"
                        v-decorator="[
                          'contactPerson-phone',
                          {
                            rules: [
                              {
                                required: true,
                                message: '请输入您的手机号码！',
                              },
                              {
                                pattern: /^1[3456789]\d{9}$/,
                                message: '手机号码格式错误',
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :span="12">
                <a-form-item label="询盘内容：">
                  <a-textarea
                    placeholder="请留下您宝贵的信息"
                    v-decorator="['demand']"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <div class="remark-block">
            <div class="help-mode-name fontsize40">专属询盘小助手</div>
            <div class="help-mode-remark fontsize20">一对一匹配优质询盘</div>
            <div class="help-mode-btn">
              <a-button type="primary" html-type="submit">
                帮我找找
              </a-button>
            </div>
          </div>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import { submitClues } from '@/api/inquiry';
export default {
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        // if (!err) {
        //   console.log('Received values of form: ', values);
        // }
        if (err) {
          return;
        }
        console.log('Received values of form: ', values);

        let params = {
          name: values['name'],
          demand: values['demand'] || '',
          contactPerson: {
            phone: values['contactPerson-phone'],
            name: values['contactPerson-name'],
          },
          industry: [
            {
              cname: values['cname'],
            },
          ],
        };

        submitClues(params).then((res) => {
          if (res.success) {
            this.$message.success('询盘信息提交成功！');
          }
          // 重置表单状态
          this.form.resetFields();
        });
      });
    },
    handleSelectChange(value) {
      console.log(value);
      this.form.setFieldsValue({
        note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,
      });
    },
  },
};
</script>

<style lang="sass" scoped>

.help-form{
  padding-top: 75px;
  padding-bottom: 60px;
 .formhelp_input{
  margin-top:12px;
 }
  // height:544px;
  background: url('~@/assets/images/背景_专属询盘小助手.jpg')
    100% no-repeat;background-size: cover;


input,textarea{
  font-size:18px; font-family: 'Alibaba-PuHuiTi-R';
}
  ::v-deep .ant-form-item-label > label{
    font-size: 20px;
    font-family: AlibabaPuHuiTiM;
    font-weight: normal;font-family: 'Alibaba-PuHuiTi-R';
    color: #FFFFFF;
    line-height: 27px;
  }

  ::v-deep input {
    // width: 500px;
    height: 66px;
    background: #FFFFFF;
    border-radius: 8px;
    opacity: 0.93;
  }
  ::v-deep textarea {
    height:211px;
    background: #FFFFFF;
    border-radius: 8px;
    opacity: 0.93;
  }

  .form-block{
    width:75%;
  }
  .remark-block{
    // width: 276px;
    padding-top: 40px;
  }

  .help-mode-name{
    font-family: AlibabaPuHuiTiM, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 55px;
  }

  .help-mode-remark{
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    padding-top:30px;
    color: #FFFFFF;
    line-height: 26px;
  }

  .help-mode-btn{
    padding-top: 171px;
    .ant-btn-primary:hover{
      background:#ddecff
    }
    .ant-btn-primary{
      width: 200px;
      height: 64px;
      background: #FFFFFF;
      border-radius: 6px;color: #2B68FF;
      font-size:20px;
    }
  }

}
</style>
